// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"86":"markdown-notes-editor","136":"markdown-notes-renderer"}[chunkId] || chunkId) + ".js";
};